import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  confirmContactValidationCode,
  confirmPasswordValidationCode,
  sendContactValidationCode,
  sendPasswordValidationCode,
  updateDefaultCompany,
  updatePassword,
  updateUser,
} from "@services/http/settings";
import { UserConstants } from "./User.enums";
import { ProfileState, SelectItem, UserStoreActions } from "./User.types";

export const additionalDocumentTypeItems: SelectItem[] = [
  { value: UserConstants.AdditionalDocumentType.IDENTITY_CARD, description: "RG" },
  { value: UserConstants.AdditionalDocumentType.DRIVER_LICENSE, description: "CNH" },
];

export const countryItems: SelectItem[] = [{ value: "Brasil", description: "Brasil" }];

export const languageItems: SelectItem[] = [{ value: "Português (BR)", description: "Português (BR)" }];

export const nationalityItems: SelectItem[] = [{ value: "Brasil", description: "Brasil" }];

export const stateItems: SelectItem[] = [
  { value: "AC", description: "Acre" },
  { value: "AL", description: "Alagoas" },
  { value: "AP", description: "Amapá" },
  { value: "AM", description: "Amazonas" },
  { value: "BA", description: "Bahia" },
  { value: "CE", description: "Ceará" },
  { value: "DF", description: "Distrito Federal" },
  { value: "ES", description: "Espírito Santo" },
  { value: "GO", description: "Goiás" },
  { value: "MA", description: "Maranhão" },
  { value: "MT", description: "Mato Grosso" },
  { value: "MS", description: "Mato Grosso do Sul" },
  { value: "MG", description: "Minas Gerais" },
  { value: "PA", description: "Pará" },
  { value: "PB", description: "Paraíba" },
  { value: "PR", description: "Paraná" },
  { value: "PE", description: "Pernambuco" },
  { value: "PI", description: "Piauí" },
  { value: "RJ", description: "Rio de Janeiro" },
  { value: "RN", description: "Rio Grande do Norte" },
  { value: "RS", description: "Rio Grande do Sul" },
  { value: "RO", description: "Rondônia" },
  { value: "RR", description: "Roraima" },
  { value: "SC", description: "Santa Catarina" },
  { value: "SP", description: "São Paulo" },
  { value: "SE", description: "Sergipe" },
  { value: "TO", description: "Tocantins" },
];

const initialState: ProfileState = {
  isLoading: false,
  additionalDocumentTypeItems,
  countryItems,
  languageItems,
  nationalityItems,
  stateItems,
};

export const useUserStore = create<UserStoreActions & ProfileState>()(
  devtools(set => ({
    ...initialState,

    confirmContactValidationCode: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await confirmContactValidationCode(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    confirmPasswordValidationCode: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await confirmPasswordValidationCode(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    sendContactValidationCode: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await sendContactValidationCode(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    sendPasswordValidationCode: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await sendPasswordValidationCode(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    updateDefaultCompany: async companyUuid => {
      set({ isLoading: true });

      try {
        await updateDefaultCompany(companyUuid);
      } finally {
        set({ isLoading: false });
      }
    },

    updatePassword: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await updatePassword(data);

        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    updateUser: async data => {
      set({ isLoading: true });

      try {
        const { data: response } = await updateUser(data);
        return response;
      } finally {
        set({ isLoading: false });
      }
    },

    setIsLoading: state => set({ isLoading: state }),
  }))
);
